<template>
    <div style="z-index: 4">
        <transition name="fade">
            <v-btn
                v-scroll="onScroll"
                v-show="show"
                @click="toTop()"
                fixed
                bottom
                right
                :ripple="false"
                class="primary"
                style="
                    min-width: initial;
                    height: initial;
                    padding: 8px;
                    max-width: 40px;
                "
                :style="
                    isAtBottom ? `transform: translateX(-${MOVE_LEFT}px)` : ''
                "
            >
                <v-icon>mdi-chevron-up</v-icon>
            </v-btn>
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            isAtBottom: false,
            MOVE_LEFT: 64,
        };
    },
    methods: {
        onScroll(e) {
            if (typeof window === "undefined") return;
            const yPos = window.pageYOffset || e.target.scrollTop || 0;
            // this.isAtBottom = this.$vuetify.breakpoint.smAndDown && document.body.clientHeight - window.innerHeight - yPos < 64;
            if (yPos > 250) this.show = true;
            else this.show = false;
        },
        toTop() {
            this.$vuetify.goTo(0);
        },
    },
    mounted() {
        // let observer = new IntersectionObserver(
        //     (entries, observer) => {
        //         entries.forEach(entry => {
        //             if (entry.intersectionRatio != 1) {
        //                 console.log("Leaving")
        //             }
        //         });
        //     }
        // );
        // observer.observe(document.getElementById('x1'));
    },
    computed: {
    },
};
</script>

<style>
</style>